import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function TableListIcon(props) {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="18" height="2" rx="1" fill={props.fill} />
			<rect y="4" width="18" height="2" rx="1" fill={props.fill} />
			<rect y="8" width="18" height="2" rx="1" fill={props.fill} />
			<rect y="12" width="18" height="2" rx="1" fill={props.fill} />
			<rect y="16" width="18" height="2" rx="1" fill={props.fill} />
		</svg>

	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<TableListIcon fill={props.fill} />
		</div>
	);
}